import { Box, Typography, useTheme } from '@mui/material'
import { useLowBalanceNotification } from 'src/providers/low-balance-notification-provider'

export const LowWalletBalanceBanner = () => {
  const theme = useTheme()

  const { isBannerVisible, balance } = useLowBalanceNotification()

  if (!isBannerVisible) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        background: theme.palette.custom.warning,
        margin: 0,
        zIndex: 100,
        position: 'relative',
        color: theme.palette.common.white,
        padding: '10px 20px',
      }}
    >
      <Typography
        sx={{ fontSize: '12px' }}
      >{`Low wallet balance: ${balance?.toFixed(5)} ETH`}</Typography>
    </Box>
  )
}
